import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
            <div class="heading01 type01">
                <h1>{{ 'user.Add competence' | translate }}</h1>
            </div>
            <div class="person01">
                <form role="form" ng-submit="vm.save()">
                    <form-wrapper form="vm.form">
                        <div class="form nomargin">
                            <form-row error="vm.form.errors.name">
                                <label class="label">{{ 'user.Competency Name' | translate }} *</label>
                                <div class="items">
                                    <div class="items">
                                        <input ng-model="vm.form.model.name" type="text" class="form-control">
                                    </div>
                                    <form-row-error></form-row-error>
                                </div>
                            </form-row>
                            <hr>
                            <h2>{{ 'user.Skills' | translate }}</h2>
                            <user-competence-competence-add-skill-item form="vm.form"></user-competence-competence-add-skill-item>
                        </div>
                        <ul class="actions01">
                            <li class="primary">
                                <input type="submit" class="btn main" value="{{ 'general.Save' | translate }}">
                            </li>
                            <li><a class="btn discrete">{{ 'general.Back' | translate }}</a></li>
                        </ul>
                    </form-wrapper>
                </form>
            </div>
    `
})
export default class {
    constructor ($state, FormFactory, FormResource, CompetenceResource) {
        this.$state = $state;
        this.FormFactory = FormFactory;
        this.CompetenceResource = CompetenceResource;
        this.FormResource = FormResource;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(new this.CompetenceResource());
    }

    save () {
        this.form.save().then(() => {
            this.$state.go('authorized.user.competence.competence.list');
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/user/competence/competence/add/index.js